import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

const servicesData = [
  {
    id: 1,
    title: "Ocean Freight",
    icon: "flaticon-ship",
    image: "/assets/img/services_img01.jpg",
    content: "Shipping freight refers to the transportation of large quantities of goods or cargo by sea, air, or land. Freight can be shipped in various types of containers such as boxes, crates, barrels, or pallets. The transportation of goods by freight is typically arranged through a shipping company or freight forwarder, which handles the logistics of the shipment, including the booking of cargo space, transportation, customs clearance, and delivery."
  },
  {
    id: 2,
    title: "Air Freight",
    icon: "flaticon-air-freight",
    image: "/assets/img/services_img03.png",
    content: "Air freight is the transportation of goods by air. It is one of the fastest ways to transport goods internationally. Air freight services are typically used for time-sensitive shipments, high-value goods, and perishable items. The process involves booking cargo space on commercial or cargo aircraft, handling customs documentation, and arranging for ground transportation to and from airports."
  },

  {
    id: 3,
    title: "Road Freight",
    icon: "flaticon-truck",
    image: "/assets/img/services_img02.png",
    content: "Road freight is the transportation of goods by truck. It is one of the most flexible and widely used modes of transportation. Road freight services provide door-to-door delivery options and are suitable for both short and long-distance shipments. The process includes route planning, vehicle scheduling, and handling customs documentation for international shipments."
  },
  {
    id: 4,
    title: "Warehouse",
    icon: "flaticon-warehouse-1",
    image: "/assets/img/services_details_inner_img.jpg",
    content: "Warehousing services provide storage solutions for goods and materials. Modern warehouses offer various services including inventory management, order fulfillment, and distribution. They are equipped with advanced technology for tracking and managing stock levels, ensuring efficient storage and retrieval of goods."
  }
];

function Services() {
  const [activeService, setActiveService] = useState(servicesData[0]);
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const [showPdfModal, setShowPdfModal] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>
       <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
      {/*Preloader*/}
      <div id="preloader" style={{ display: "none" }}>
        <div className="tg-preloader-block">
          <div className="tg-spinner-eff">
            <div className="tg-bar tg-bar-top" />
            <div className="tg-bar tg-bar-right" />
            <div className="tg-bar tg-bar-bottom" />
            <div className="tg-bar tg-bar-left" />
          </div>
        </div>
      </div>
      {/*Preloader-end */}
      {/* Scroll-top */}
      <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
      {/* Scroll-top-end*/}
      {/* header-area */}
      <HeaderBest/>
      {/* header-area-end */}
      {/* main-area */}
      <main className="fix">
        {/* breadcrumb-area */}
        <section
          className="breadcrumb__area breadcrumb__bg"
          data-background="/assets/img/breadcrumb_bg.jpg"
          style={{ backgroundImage: 'url("/assets/img/breadcrumb_bg.jpg")' }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcrumb__content">
                  <h1 className="title">Service Details</h1>
                  <nav className="breadcrumb">
                    <span property="itemListElement" typeof="ListItem">
                      <a href="/">Home</a>
                    </span>
                    <span className="breadcrumb-separator">
                      <i className="flaticon-right-arrow" />
                    </span>
                    <span property="itemListElement" typeof="ListItem">
                      Service Details
                    </span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* breadcrumb-area-end */}
        {/* services-details-area */}
        <section className="services__details-area section-py-130">
          <div className="container">
            <div className="services__details-inner">
              <div className="row">
                <div className="col-70 order-0 order-lg-2">
                  <div className="services__details-thumb">
                    <img src={activeService.image} alt="img" />
                  </div>
                  <div className="services__details-content">
                    <h2 className="title">{activeService.title}</h2>
                    <p>{activeService.content}</p>
                    <div className="services__details-content-inner">
                      <div className="row align-items-end">
                        <div className="col-md-12">
                          <h2 className="title-two">
                            Global Logistics Excellence
                          </h2>
                          <p>
                            At MTL Ship, we redefine global supply chain management through our comprehensive network spanning across continents. Our expertise in multimodal transportation, customs clearance, and supply chain optimization ensures your cargo reaches its destination with maximum efficiency and reliability. We combine cutting-edge technology with decades of industry experience to deliver seamless logistics solutions tailored to your specific needs.
                          </p>
                        </div>
                     
                      </div>
                    </div>
                    <div className="services__details-content-inner-two">
                      <div className="row gutter-24">
                        <div className="col-44">
                          <div className="services__details-inner-img">
                            <img
                              src="/assets/img/services_details_inner_img.jpg"
                              alt="img"
                              style={{
                                width: '100%',
                                height: 'auto',
                                display: 'block',
                                objectFit: 'cover'
                              }}
                            />
                            <a
                              href="http://www.youtube.com/watch?v=1iIZeIy7TqM"
                              className="play-btn popup-video"
                              style={{display: 'none'}}
                            >
                              <i className="fas fa-play" />
                            </a>
                          </div>
                        </div>
                        <div className="col-56">
                          <h2 className="title-two">
                            Advanced Supply Chain Solutions
                          </h2>
                          <p>
                            Our integrated logistics services leverage state-of-the-art technology and industry expertise to optimize your supply chain operations. From warehousing to last-mile delivery, we ensure seamless coordination and maximum efficiency at every stage of the logistics process. Our comprehensive approach combines real-time tracking, advanced analytics, and expert management to deliver superior results.
                          </p>
                          <div className="about__list-box about__list-box-two about__list-box-three">
                            <ul className="list-wrap">
                              <li>
                                <i className="flaticon-check" />
                                Real-Time Cargo Tracking & Monitoring
                              </li>
                              <li>
                                <i className="flaticon-check" />
                                Customized Logistics Solutions
                              </li>
                              <li>
                                <i className="flaticon-check" />
                                Global Network Coverage
                              </li>
                              <li>
                                <i className="flaticon-check" />
                                Advanced Security Protocols
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="services__details-benefit">
                      <h2 className="title-two">Why Choose MTL Ship?</h2>
                      <p>
                        We stand at the forefront of the logistics industry, combining decades of experience with innovative technology to provide reliable, efficient, and cost-effective solutions. Our commitment to excellence ensures your cargo is handled with the utmost care and professionalism at every stage of its journey. With our global network and dedicated team, we deliver peace of mind and exceptional service quality.
                      </p>
                      <div className="faq__wrap">
                        <div className="accordion" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                What Sets MTL Ship Apart?
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <p>
                                  Our logistics services distinguish themselves through our comprehensive global network, advanced tracking systems, and dedicated customer support. We offer tailored solutions that adapt to your specific needs while maintaining the highest standards of efficiency and reliability. Our commitment to innovation and customer satisfaction drives us to continuously improve and exceed expectations.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                              >
                                How Do We Ensure Cargo Safety?
                              </button>
                            </h2>
                            <div
                              id="collapseTwo"
                              className="accordion-collapse collapse"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <p>
                                  We implement rigorous security measures including 24/7 monitoring, GPS tracking, and secure handling procedures. Our trained professionals and advanced technology work together to ensure your cargo's safety throughout the entire transportation process. We maintain strict compliance with international safety standards and continuously update our security protocols to address emerging challenges.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                              >
                                What Types of Cargo Do We Handle?
                              </button>
                            </h2>
                            <div
                              id="collapseThree"
                              className="accordion-collapse collapse"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <p>
                                  We handle a diverse range of cargo types including general cargo, temperature-controlled shipments, hazardous materials, and oversized loads. Our specialized equipment and trained staff ensure proper handling of all cargo types according to international standards. We provide customized solutions for each type of cargo, ensuring optimal conditions and safe transportation throughout the journey.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-30">
                  <aside className="services__sidebar">
                    <div className="services__widget">
                      <div className="services__cat-list">
                        <ul className="list-wrap">
                          {servicesData.map((service) => (
                            <li key={service.id}>
                              <a 
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveService(service);
                                }}
                                className={activeService.id === service.id ? 'active' : ''}
                              >
                                <span>
                                  <i className={service.icon} />
                                  {service.title}
                                </span>{" "}
                                <i className="flaticon-right-arrow" />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="services__widget services__widget-two">
                      <div className="sidebar__logo">
                        <Link to="/">
                          <img src="/assets/img/mtllogo.png" alt="logo" />
                        </Link>
                      </div>
                      <div className="sidebar__contact">
                        <h2 className="title">
                          Logistics &amp; Cargo <br /> for Business
                        </h2>
                        <a href="tel:+18325621002" className="sidebar__phone">
                          <i className="flaticon-telephone" />
                          (+1) 832 562 1002
                        </a>
                        <a href="/contact" className="btn">
                          Contact With us{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={13}
                            height={13}
                            viewBox="0 0 13 13"
                            fill="none"
                            data-inject-url="https://themeadapt.com/tf/logistex/assets/img/icon/right_arrow.svg"
                            className="injectable"
                          >
                            <path
                              d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                              stroke="currentcolor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                              stroke="currentcolor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                      <div
                        className="sidebar__shape"
                        data-background="assets/img/services_sidebar_shape.png"
                        style={{
                          backgroundImage:
                            'url("assets/img/services_sidebar_shape.png")'
                        }}
                      />
                    </div>
                    <div className="services__widget services__widget-three">
                      <h4 className="sidebar__widget-title">Brochure</h4>
                      <div className="sidebar__brochure">
                        <p>
                          Your trusted partner in global logistics solutions, delivering excellence with precision and care.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowPdfModal(true);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={17}
                            height={21}
                            viewBox="0 0 17 21"
                            fill="none"
                            data-inject-url="https://themeadapt.com/tf/logistex/assets/img/icon/pdf.svg"
                            className="injectable"
                          >
                            <path
                              d="M15.2812 5.90613V5.80073L15.5938 6.11323V18.3749C15.5938 18.9385 15.3699 19.479 14.9714 19.8775C14.5728 20.276 14.0323 20.4999 13.4688 20.4999H2.96875C2.40516 20.4999 1.86466 20.276 1.46615 19.8775C1.06763 19.479 0.84375 18.9385 0.84375 18.3749V2.62488C0.84375 2.06129 1.06763 1.52079 1.46615 1.12228C1.86466 0.723761 2.40516 0.499878 2.96875 0.499878H9.98039L10.2929 0.812378H10.1875H2.96875C2.48805 0.812378 2.02703 1.00334 1.68712 1.34325C1.34721 1.68316 1.15625 2.14417 1.15625 2.62488V18.3749C1.15625 18.8556 1.34721 19.3166 1.68712 19.6565C2.02703 19.9964 2.48805 20.1874 2.96875 20.1874H13.4688C13.9495 20.1874 14.4105 19.9964 14.7504 19.6565C15.0903 19.3166 15.2812 18.8556 15.2812 18.3749V5.90613ZM10.6875 1.20699L14.8866 5.40613H14.7812H12.1562C11.7667 5.40613 11.3931 5.25139 11.1177 4.97594C10.8422 4.7005 10.6875 4.32691 10.6875 3.93738V1.31238V1.20699ZM6.93479 14.9568L6.85539 14.9803L6.97674 14.8001L6.84726 14.8594L6.8497 14.855C6.97749 14.6253 7.10181 14.3937 7.22263 14.1603V14.2471V14.2484V14.8745C7.12644 14.901 7.03049 14.9284 6.93479 14.9568ZM8.33491 11.7323L8.26002 11.9016C8.26353 11.8929 8.26703 11.8842 8.27053 11.8755L8.3402 11.7023L8.42076 11.8745C8.44344 11.9231 8.46639 11.9714 8.48959 12.0197L8.33491 11.7323ZM8.40611 11.4856L8.3401 11.6599L8.26427 11.4876C8.15611 11.2418 8.05901 10.9915 7.97322 10.7374H8.32113H8.32244H8.67166C8.59204 10.9791 8.50317 11.2294 8.40611 11.4856ZM10.1993 14.3741C10.2772 14.3679 10.3551 14.3631 10.433 14.3595V14.839V14.8403V15.0117C10.3157 14.8792 10.2034 14.7423 10.0963 14.6011L9.93961 14.3946L10.1993 14.3741ZM9.80993 14.2466L9.9021 14.3769L9.79303 14.3893L9.89336 14.3743L9.80993 14.2466Z"
                              fill="currentcolor"
                              stroke="currentcolor"
                            />
                          </svg>
                          PDF. Download
                        </a>
                      </div>
                    </div>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* services-details-area-end */}
        {/* cta-area */}

        {/* cta-area-end */}
      </main>

      {/* main-area-end */}
      {/* footer-area */}
      <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/15516559226" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
      {/* footer-area-end */}
      {/* JS here */}
      {/* PDF Modal */}
      {showPdfModal && (
        <div 
          className="pdf-modal" 
          onClick={() => setShowPdfModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '90%',
              height: '90%',
              position: 'relative'
            }}
          >
            <button 
              onClick={() => setShowPdfModal(false)}
              style={{
                position: 'absolute',
                right: '-10px',
                top: '-40px',
                background: 'none',
                border: 'none',
                fontSize: '52px',
                cursor: 'pointer',
                zIndex: 10000,
                color: 'red',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'all 0.3s ease',
                ':hover': {
                  backgroundColor: 'rgba(0,0,0,0.1)'
                }
              }}
            >
              ×
            </button>
            <div style={{ height: '100%' }}>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer
                  fileUrl="/assets/img/mtl_sunum.pdf"
                  plugins={[defaultLayoutPluginInstance]}
                />
              </Worker>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Services;

